// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `animated-header ion-header {
  opacity: 0;
  transition: opacity 300ms ease-in-out;
}
animated-header ion-header.visible {
  opacity: 1;
}
animated-header ion-header ion-title {
  opacity: 0;
  -webkit-transition: all 400ms ease-in-out;
  -webkit-transform: translate(40px, 15px) !important;
  -ms-transition: all 400ms ease-in-out;
  -ms-transform: translate(40px, 15px);
  -moz-transition: all 400ms ease-in-out;
  -moz-transform: translate(40px, 15px);
  transition: all 400ms ease-in-out;
  transform: translate(40px, 15px);
}
animated-header ion-header ion-title.animate {
  opacity: 1;
  transform: translate(40px, 0px);
}
animated-header .toolbar-ios {
  min-height: 56px;
}
animated-header .toolbar-ios .toolbar-title-ios {
  text-align: left;
}
animated-header #fixed-menu-button .button-ios {
  margin-top: -0.6rem;
}
animated-header #fixed-menu-button {
  top: 10px;
  position: absolute;
  z-index: 999;
  text-transform: capitalize;
  background-color: rgba(0, 0, 255, 0);
}
animated-header #fixed-menu-button > button {
  background-color: rgba(0, 0, 255, 0) !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
animated-header #fixed-menu-button.visible ion-icon {
  color: inherit !important;
}
animated-header ion-content .fixed-content {
  margin-top: 0;
  background: url('background-plane.jpg');
  background-size: cover;
  background-position: right;
  height: 400px !important;
  width: 100% !important;
  object-fit: cover !important;
}
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  animated-header #fixed-menu-button .button-ios {
    top: 5px !important;
    font-size: 20px !important;
  }
  animated-header .toolbar-ios .toolbar-title-ios {
    text-align: left;
    top: 40px;
    margin-top: 12px;
    text-transform: capitalize;
  }
}
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  animated-header #fixed-menu-button .button-ios {
    top: 25px !important;
    font-size: 20px !important;
  }
  animated-header .toolbar-ios .toolbar-title-ios {
    text-align: left;
    top: 40px;
    margin-top: 30px;
    text-transform: capitalize;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/animated-header/animated-header.component.scss"],"names":[],"mappings":"AAGE;EACE,UAAA;EAKA,qCAAA;AAHJ;AAKE;EACE,UAAA;AAHJ;AAME;EACE,UAAA;EAEA,yCAAA;EACA,mDAAA;EACA,qCAAA;EACA,oCAAA;EACA,sCAAA;EACA,qCAAA;EACA,iCAAA;EACA,gCAAA;AALJ;AAOE;EACE,UAAA;EAKA,+BAAA;AANJ;AAUE;EACE,gBAAA;AARJ;AASI;EACE,gBAAA;AAPN;AAWI;EACE,mBAAA;AATN;AAaE;EACE,SAAA;EACA,kBAAA;EACA,YAAA;EACA,0BAAA;EACA,oCAAA;AAXJ;AAYI;EACE,+CAAA;EACA,2BAAA;EACA,mCAAA;AAVN;AAcI;EACE,yBAAA;AAZN;AAgBI;EACE,aAAA;EACA,uCAAA;EACA,sBAAA;EACA,0BAAA;EACA,wBAAA;EACA,sBAAA;EACA,4BAAA;AAdN;AAiBE;EAEI;IACE,mBAAA;IACA,0BAAA;EAhBN;EAoBI;IACE,gBAAA;IACA,SAAA;IACA,gBAAA;IACA,0BAAA;EAlBN;AACF;AAqBE;EAEI;IACE,oBAAA;IACA,0BAAA;EApBN;EAwBI;IACE,gBAAA;IACA,SAAA;IACA,gBAAA;IACA,0BAAA;EAtBN;AACF","sourcesContent":["$animationSpeed: 400ms;\n$opacitySpeed: 300ms;\nanimated-header {\n  ion-header {\n    opacity: 0;\n\n    -webkit-transition: opacity $opacitySpeed ease-in-out;\n    -ms-transition: opacity $opacitySpeed ease-in-out;\n    -moz-transition: opacity $opacitySpeed ease-in-out;\n    transition: opacity $opacitySpeed ease-in-out;\n  }\n  ion-header.visible {\n    opacity: 1;\n  }\n\n  ion-header ion-title {\n    opacity: 0;\n\n    -webkit-transition: all $animationSpeed ease-in-out;\n    -webkit-transform: translate(40px, 15px) !important;\n    -ms-transition: all $animationSpeed ease-in-out;\n    -ms-transform: translate(40px, 15px);\n    -moz-transition: all $animationSpeed ease-in-out;\n    -moz-transform: translate(40px, 15px);\n    transition: all $animationSpeed ease-in-out;\n    transform: translate(40px, 15px);\n  }\n  ion-header ion-title.animate {\n    opacity: 1;\n\n    -webkit-transform: translate(40px, 0px) !important;\n    -ms-transform: translate(40px, 0px);\n    -moz-transform: translate(40px, 0px);\n    transform: translate(40px, 0px);\n  }\n\n  // Some iOS overrides\n  .toolbar-ios {\n    min-height: 56px;\n    .toolbar-title-ios {\n      text-align: left;\n    }\n  }\n  #fixed-menu-button {\n    .button-ios {\n      margin-top: -0.6rem;\n    }\n  }\n\n  #fixed-menu-button {\n    top: 10px;\n    position: absolute;\n    z-index: 999;\n    text-transform: capitalize;\n    background-color: rgba(0, 0, 255, 0);\n    > button {\n      background-color: rgba(0, 0, 255, 0) !important;\n      box-shadow: none !important;\n      -webkit-box-shadow: none !important;\n    }\n  }\n  #fixed-menu-button.visible {\n    ion-icon {\n      color: inherit !important;\n    }\n  }\n  ion-content {\n    .fixed-content {\n      margin-top: 0;\n      background: url(\"../../../../assets/imgs/background-plane.jpg\");\n      background-size: cover;\n      background-position: right;\n      height: 400px !important;\n      width: 100% !important;\n      object-fit: cover !important;\n    }\n  }\n  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {\n    #fixed-menu-button {\n      .button-ios {\n        top: 5px !important;\n        font-size: 20px !important;\n      }\n    }\n    .toolbar-ios {\n      .toolbar-title-ios {\n        text-align: left;\n        top: 40px;\n        margin-top: 12px;\n        text-transform: capitalize;\n      }\n    }\n  }\n  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {\n    #fixed-menu-button {\n      .button-ios {\n        top: 25px !important;\n        font-size: 20px !important;\n      }\n    }\n    .toolbar-ios {\n      .toolbar-title-ios {\n        text-align: left;\n        top: 40px;\n        margin-top: 30px;\n        text-transform: capitalize;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
